import React, { useState } from 'react'
import { Password } from '../Common/V2'
import { PasswordInputStyled } from './PasswordInput.styled'
import { PasswordCriteriaList } from './PasswordCriteriaList'
import { validatePassword, PasswordCriteria } from './helpers/validatePassword'

export type OnPasswordInputChangeProps = {
  password: string
  canContinue: boolean
}

type PasswordInputProps = {
  onPasswordInputChange: ({ password, canContinue }: OnPasswordInputChangeProps) => void
  isDisabled: boolean
}

export const PasswordInput = ({ onPasswordInputChange, isDisabled }: PasswordInputProps) => {
  const [password, setPassword] = useState('')
  const [passwordUnmetCriteria, setPasswordUnmetCriteria] = useState<PasswordCriteria[]>([
    PasswordCriteria.containsNumberOrSpecialCharacter,
    PasswordCriteria.containsUpperAndLowerLetters,
    PasswordCriteria.sufficientLength,
  ])
  const [confirmationPassword, setConfirmationPassword] = useState('')
  const [confirmationPasswordError, setConfirmationPasswordError] = useState('')

  React.useEffect(() => {
    const isPasswordValid = passwordUnmetCriteria.length === 0
    const doPasswordsMatch = password === confirmationPassword
    onPasswordInputChange({
      password: password,
      canContinue: isPasswordValid && doPasswordsMatch,
    })
  }, [password, confirmationPassword, passwordUnmetCriteria, onPasswordInputChange])

  return (
    <PasswordInputStyled>
      <Password
        name='password'
        label='Password'
        value={password}
        onInput={e => {
          setPassword(e.currentTarget.value)
          setConfirmationPasswordError('')

          const { unmetCriteria } = validatePassword(e.currentTarget.value)
          setPasswordUnmetCriteria(unmetCriteria)
        }}
        onBlur={() => {
          if (confirmationPassword.length > 0 && password !== confirmationPassword) {
            setConfirmationPasswordError('The passwords do not match.')
          }
        }}
        isDisabled={isDisabled}
      />

      <PasswordCriteriaList unmetCriteria={passwordUnmetCriteria} />

      <Password
        name='confirm-password'
        label='Confirm Password'
        isInvalid={!!confirmationPasswordError}
        helpText={confirmationPasswordError}
        value={confirmationPassword}
        onInput={e => {
          setConfirmationPassword(e.currentTarget.value)
          setConfirmationPasswordError('')
        }}
        onBlur={() => {
          if (confirmationPassword !== password) {
            setConfirmationPasswordError('The passwords do not match.')
          }
        }}
        isDisabled={isDisabled}
      />
    </PasswordInputStyled>
  )
}
